import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "../components/PageHero";
import { FeatureList, CTASection } from "../components/Sections";
import { ComplianceBanner } from "../components/ComplianceBanner";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../data/config";

export default function SmartBag() {
  const { t } = useTranslation();
  return (
    <>
      <PageHero
        overline={t("smartbag.overline")}
        title={<>{t("smartbag.titleA")} <span className="text-gradient-gold">{t("smartbag.titleAccent")}</span></>}
        subtitle={t("smartbag.subtitle")}
        image={IMAGES.baggage}
        accent="signal"
        testId="smartbag-hero"
      />
      <FeatureList
        overline={t("smartbag.featOverline")}
        title={t("smartbag.featTitle")}
        accent="signal"
        items={t("smartbag.features", { returnObjects: true })}
      />
      <section className="pb-8">
        <div className="container-x"><Reveal><ComplianceBanner text={t("smartbag.banner")} /></Reveal></div>
      </section>
      <CTASection title={t("smartbag.ctaTitle")} subtitle={t("smartbag.ctaSub")} ctaLabel={t("smartbag.ctaLabel")} ctaTo="/quote?plan=essential" testId="smartbag-cta" />
    </>
  );
}
